import { render } from "./ButtonGroup.vue?vue&type=template&id=b65f515c"
import script from "./ButtonGroup.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__